import { gql } from '@apollo/client'

export const PUBLISH_UNPUBLISH_SITE = gql`
  mutation PUBLISH_UNPUBLISH_SITE($id: ID!, $publish: Boolean!) {
    publishUnpublishSite(id: $id, publish: $publish) {
      id
    }
  }
`
